document.addEventListener('DOMContentLoaded', () => {
  const stages404 = document.querySelectorAll('.s-404-stage')

  stages404.forEach((stage) => {
    const footer = document.querySelector('.n-footer')
    console.log(stage)
    setStageHeight()

    window.addEventListener('resize', () => {
      setStageHeight()
    })
    function setStageHeight () {
      if (footer) {
        const footerHeight = footer.offsetHeight

        if (footerHeight && footerHeight <= window.innerHeight) {
          stage.style.minHeight = window.innerHeight - footerHeight + 'px'
        } else {
          stage.style.minHeight = 0 + 'px'
        }
      } else {
        stage.style.minHeight = 100 + 'vh'
      }
    }
  })
})
